import { render, staticRenderFns } from "./FilterObjectStoreLink.vue?vue&type=template&id=1a4f89b6"
import script from "./FilterObjectStoreLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterObjectStoreLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports